import { useSnackbar } from "notistack";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  Category,
  convertCategoryEntityListToCategoryList,
  sampleCategories,
  Subcategory,
} from "../../../domain/model/Category";
import { GetAllCategoriesUseCase } from "../../../domain/usecase/category/getAll/GetAllUseCase";
import { State } from "../../../domain/model/ResponseState";
import { getLifelines, Lifeline } from "../../../domain/model/Lifeline";
import { GetNumberOfRemainingQuestionsUseCase } from "../../../domain/usecase/question/getNumberOfRemainingQuestions/GetNumberOfRemainingQuestionsUseCase";
import {
  Difficulty,
  SubcategoryNumberOfQuestionsModel,
} from "../../../domain/model/Question";
import { calculateGamesLeftForSubcategory } from "../../../core/utils/Utils";
import { useNavigate } from "react-router-dom";
import { ROUTE_ENDPOINTS } from "../../../data/constant/RouteConstants";
import {
  Game,
  GameData,
  Platform,
  TeamTurns,
} from "../../../domain/model/Game";
import { PlayerGameStartedUseCase } from "../../../domain/usecase/player/GameStarted/GameStartedUseCase";
import { PlayerAddToGamesUseCase } from "../../../domain/usecase/player/AddToGames/AddToGamesUseCase";
import { browserName } from "react-device-detect";

export function NewGameViewModel(
  getAllCategoriesUseCase: GetAllCategoriesUseCase,
  getNumberOfRemainingQuestionsUseCase: GetNumberOfRemainingQuestionsUseCase,
  playerGameStartedUseCase: PlayerGameStartedUseCase,
  playerAddToGamesUseCase: PlayerAddToGamesUseCase,
  shouldChooseCategoryDirectly: boolean
) {
  const { enqueueSnackbar } = useSnackbar();

  const { t } = useTranslation();

  const [currentPage, setCurrentPage] = useState(NewGamePage.CHOOSE_NAME);
  const [activeStep, setActiveStep] = useState(0);

  const [shouldPlaySounds, setShouldPlaySounds] = useState(true);
  const [canAnyTeamChooseAnyQuestion, setCanAnyTeamChooseAnyQuestion] =
    useState(false);
  const [difficultiesMap, setDifficultiesMap] = useState<
    Map<Difficulty, number>
  >(
    new Map([
      [Difficulty.EASY, 60],
      [Difficulty.MEDIUM, 60],
      [Difficulty.HARD, 60],
    ])
  );

  const [firstTeamName, setFirstTeamName] = useState("");
  const [secondTeamName, setSecondTeamName] = useState("");

  const [firstTeamLifelines, setFirstTeamLifelines] = useState<Array<Lifeline>>(
    getLifelines(t)
  );
  const [secondTeamLifelines, setSecondTeamLifelines] = useState<
    Array<Lifeline>
  >(getLifelines(t));

  const [loading, setLoading] = useState(false);
  const [gameStartingLoading, setGameStartingLoading] = useState(false);

  const totalPages = Object.values(NewGamePage).length;

  const [categories, setCategories] = useState<Array<Category>>([]);
  const [selectedCategory, setSelectedCategory] = useState<
    Category | undefined
  >();

  const navigate = useNavigate();

  useEffect(() => {
    getCategories();
  }, []);

  // remove this
  // useEffect(() => {
  //   if (
  //     categories.length == 0 ||
  //     categories.filter((c) => c.isSelected).length == 6
  //   )
  //     return;

  //   setFirstTeamName("Team 1");
  //   setSecondTeamName("Team 2");

  //   const shit = [...categories];
  //   shit.map((c, i) => {
  //     if (i < 6) {
  //       c.subcategories.map((s) => {
  //         s.isSelected = true;
  //       });
  //       c.isSelected = true;
  //     }
  //   });
  //   setCategories(shit);

  //   const shit1 = [...firstTeamLifelines];
  //   shit1.map((c, i) => {
  //     if (i < 3) {
  //       c.selected = true;
  //     }
  //   });
  //   setFirstTeamLifelines(shit1);

  //   const shit2 = [...secondTeamLifelines];
  //   shit2.map((c, i) => {
  //     if (i < 3) {
  //       c.selected = true;
  //     }
  //   });
  //   setSecondTeamLifelines(shit2);
  // }, [categories]);
  // remove this

  async function getCategories() {
    setLoading(true);
    const response = await getAllCategoriesUseCase.invoke(true);
    setLoading(false);
    switch (response.responseState) {
      case State.Success:
        console.log(response.data);
        if (response.data) {
          setCategories(convertCategoryEntityListToCategoryList(response.data));
          getNumberOfRemainingQuestions(
            convertCategoryEntityListToCategoryList(response.data)
          );
        }
        break;
      case State.Fail:
      case State.Error:
        showSnackbar(response.error?.message);
        break;
    }
  }

  async function getNumberOfRemainingQuestions(categories: Array<Category>) {
    const response = await getNumberOfRemainingQuestionsUseCase.invoke(
      categories.flatMap((c) => c.id)
    );
    switch (response.responseState) {
      case State.Success:
        console.log(response.data);
        if (response.data) {
          updateCategoriesNumberOfQuestions(categories, response.data);
        }
        break;
      case State.Fail:
      case State.Error:
        showSnackbar(response.error?.message);
        getNumberOfRemainingQuestions(categories);
        break;
    }
  }

  function updateCategoriesNumberOfQuestions(
    categories: Array<Category>,
    numbersList: Array<Array<SubcategoryNumberOfQuestionsModel>>
  ) {
    const categoriesList = categories;
    categoriesList.map((c, i) => {
      c.numberOfQuestionsForEachSubcategory = numbersList[i];

      const subcategories = c.subcategories;

      subcategories.map((s, j) => {
        if (calculateGamesLeftForSubcategory(c, s) == 0) {
          s.isSelected = false;
        }
      });
    });
    setCategories(categoriesList);
  }

  function onCategoryClicked(category: Category, closePopover?: () => void) {
    const index = categories.findIndex((c) => c.id == category.id);
    if (index == -1) return;

    if (
      category.numberOfQuestionsForEachSubcategory?.length == 0 ||
      category.numberOfQuestionsForEachSubcategory == null
    ) {
      showSnackbar(t("you_cant_choose_this_category_as_there_are_no_question"));
      return;
    }

    if (!category.isSelected) {
      if (
        categories[index].subcategories.filter((s) => s.isSelected).length == 0
      ) {
        showSnackbar(t("you_should_choose_one_subcategory"));
        return;
      }

      if (categories.filter((c) => c.isSelected).length > 5) {
        showSnackbar(t("you_can_only_choose_maximum_6_categories"));
        return;
      }

      if (
        !shouldChooseCategoryDirectly &&
        category.numberOfQuestionsForEachSubcategory != null
      ) {
        var totalEasyQuestionsNumber = 0;
        var totalMediumQuestionsNumber = 0;
        var totalHardQuestionsNumber = 0;
        category.subcategories.map((item) => {
          if (item.isSelected) {
            var easyQuestionsNumber =
              category.numberOfQuestionsForEachSubcategory!.filter(
                (e) => e.subcategory == item.title
              )[0].easyDifficultyTotalQuestions;
            var mediumQuestionsNumber =
              category.numberOfQuestionsForEachSubcategory!.filter(
                (e) => e.subcategory == item.title
              )[0].mediumDifficultyTotalQuestions;
            var hardQuestionsNumber =
              category.numberOfQuestionsForEachSubcategory!.filter(
                (e) => e.subcategory == item.title
              )[0].hardDifficultyTotalQuestions;

            totalEasyQuestionsNumber += easyQuestionsNumber;
            totalMediumQuestionsNumber += mediumQuestionsNumber;
            totalHardQuestionsNumber += hardQuestionsNumber;
          }
        });

        if (
          totalEasyQuestionsNumber < 2 ||
          totalMediumQuestionsNumber < 2 ||
          totalHardQuestionsNumber < 2
        ) {
          showSnackbar(t("not_enough_questions_choose_more_subcategories"));
          return;
        }
      }
    }

    const categoriesList = [...categories];
    categoriesList[index].isSelected = !category.isSelected;
    setCategories(categoriesList);

    if (closePopover) closePopover();
  }

  function onCategoryDoubleClicked(category: Category) {
    const index = categories.findIndex((c) => c.id == category.id);
    if (index == -1) return;
    const categoriesList = [...categories];
    categoriesList[index].subcategories.map((s) => {
      if (calculateGamesLeftForSubcategory(category, s) != 0) {
        s.isSelected = true;
      }
    });
    setCategories(categoriesList);
  }

  function onSubcategoryClicked(category: Category, subcategory: Subcategory) {
    const index = categories.findIndex((c) => c.id == category.id);
    if (index == -1) return;

    if (category.isSelected && subcategory.isSelected) {
      if (category.subcategories.filter((s) => s.isSelected).length == 1) {
        showSnackbar(t("chosen_category_should_have_at_least_one_subcategory"));
        return;
      }
    }
    const categoriesList = [...categories];
    categoriesList[index].subcategories.map((s) => {
      if (s.title == subcategory.title) {
        s.isSelected = !s.isSelected;
      }
    });
    setCategories(categoriesList);
  }

  function handleOnLifelinesClicked(
    lifelineId: string,
    isForFirstTeam: boolean
  ) {
    const index = isForFirstTeam
      ? firstTeamLifelines.findIndex((l) => l.id == lifelineId)
      : secondTeamLifelines.findIndex((l) => l.id == lifelineId);
    const lifeline = isForFirstTeam
      ? firstTeamLifelines[index]
      : secondTeamLifelines[index];
    if (index == -1) return;
    const lifelines = isForFirstTeam
      ? [...firstTeamLifelines]
      : [...secondTeamLifelines];

    if (
      lifelines.filter((l) => l.selected).length === 3 &&
      !lifeline.selected
    ) {
      return;
    }
    lifelines[index].selected = !lifeline.selected;

    if (isForFirstTeam) setFirstTeamLifelines(lifelines);
    else setSecondTeamLifelines(lifelines);
  }

  const handleOnFirstTeamNameChanged = (txt: string) => {
    setFirstTeamName(txt);
  };
  const handleOnSecondTeamNameChanged = (txt: string) => {
    setSecondTeamName(txt);
  };

  const handleNext = () => {
    if (currentPage == NewGamePage.CHOOSE_NAME) {
      if (!firstTeamName || !secondTeamName) {
        showSnackbar(t("choose_teams_name"));
        return;
      }
      setCurrentPage(NewGamePage.CHOOSE_CATEGORIES);
      setActiveStep(2);
      return;
    }
    if (currentPage == NewGamePage.CHOOSE_CATEGORIES) {
      if (categories.filter((c) => c.isSelected).length != 6) {
        showSnackbar(t("should_choose_6_categories_before_satrting_game"));
        return;
      }
    }
    setCurrentPage(Object.values(NewGamePage)[activeStep + 1]);
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    if (currentPage == NewGamePage.CHOOSE_CATEGORIES) {
      setCurrentPage(NewGamePage.CHOOSE_NAME);
      setActiveStep(0);
      return;
    }
    setCurrentPage(Object.values(NewGamePage)[activeStep - 1]);
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleOnSettingsClicked = () => {
    if (!firstTeamName || !secondTeamName) {
      showSnackbar(t("choose_teams_name"));
      return;
    }
    setCurrentPage(NewGamePage.SETTINGS);
    setActiveStep(1);
  };

  const startGame = async (isMobile: boolean) => {
    if (firstTeamLifelines.filter((l) => l.selected).length != 3) {
      showSnackbar(t("first_team_should_choose_3_lifelines"));
      return;
    }
    if (secondTeamLifelines.filter((l) => l.selected).length != 3) {
      showSnackbar(t("second_team_should_choose_3_lifelines"));
      return;
    }

    const resultGame = await addToUserGames(isMobile);
    if (!resultGame) return;
    if (!(await decreaseFromGamesNumber())) return;

    const gameData: GameData = {
      firstTeamName,
      secondTeamName,
      categories: categories.filter((c) => c.isSelected),
      firstTeamLifelines: firstTeamLifelines
        .filter((l) => l.selected)
        .map((l) => {
          l.selected = false;
          return l;
        }),
      secondTeamLifelines: secondTeamLifelines
        .filter((l) => l.selected)
        .map((l) => {
          l.selected = false;
          return l;
        }),
      difficultiesMap,
      shouldPlaySounds,
      canAnyTeamChooseAnyQuestion,
      isLoading: false,
      firstTeamScore: 0,
      secondTeamScore: 0,
      currentTeamTurn: TeamTurns.teamA,
      resultGame,
    };

    navigate(ROUTE_ENDPOINTS.GAME, { state: gameData });
  };

  async function addToUserGames(isMobile: boolean): Promise<Game | undefined> {
    setGameStartingLoading(true);
    const gameSelectedCategories: Array<{
      category: string;
      selectedSubcategoriesIndexes: Array<number>;
    }> = [];
    categories
      .filter((c) => c.isSelected)
      .map((category) => {
        const selectedSubcategoriesIndexes: Array<number> =
          category.subcategories
            .filter((s) => s.isSelected)
            .flatMap((_, idx) => idx);
        gameSelectedCategories.push({
          category: category.id,
          selectedSubcategoriesIndexes: selectedSubcategoriesIndexes,
        });
      });
    const response = await playerAddToGamesUseCase.invoke({
      score: 0,
      selectedCategories: gameSelectedCategories,
      firstTeamName,
      secondTeamName,
      shouldPlaySounds,
      canAnyTeamChooseAnyQuestion,
      isPlayedInTrialMode: shouldChooseCategoryDirectly,
      firstTeamLifelinesList: firstTeamLifelines
        .filter((i) => i.selected)
        .flatMap((i) => i.type),
      secondTeamLifelinesList: secondTeamLifelines
        .filter((i) => i.selected)
        .flatMap((i) => i.type),
      difficultiesMap: {
        easy: difficultiesMap.get(Difficulty.EASY) ?? 60,
        medium: difficultiesMap.get(Difficulty.MEDIUM) ?? 60,
        hard: difficultiesMap.get(Difficulty.HARD) ?? 60,
      },
      platform: isMobile ? Platform.WEB_MOBILE : Platform.WEB,
      device: browserName,
    });

    switch (response.responseState) {
      case State.Success:
        return response.data;
      case State.Fail:
      case State.Error:
        setGameStartingLoading(false);
        showSnackbar(response.error?.message);
        break;
    }
  }

  async function decreaseFromGamesNumber(): Promise<boolean> {
    const response = await playerGameStartedUseCase.invoke();
    switch (response.responseState) {
      case State.Success:
        setGameStartingLoading(false);
        return true;
      case State.Fail:
      case State.Error:
        showSnackbar(response.error?.message);
        break;
    }
    setGameStartingLoading(false);
    return false;
  }

  function showSnackbar(
    message: string | undefined,
    variant: "error" | "success" = "error"
  ) {
    if (message) enqueueSnackbar(message, { variant: variant });
  }

  return {
    currentPage,
    activeStep,
    totalPages,
    handleNext,
    handleBack,
    handleOnSettingsClicked,
    firstTeamName,
    secondTeamName,
    handleOnFirstTeamNameChanged,
    handleOnSecondTeamNameChanged,
    categories,
    setSelectedCategory,
    selectedCategory,
    loading,
    firstTeamLifelines,
    secondTeamLifelines,
    onCategoryClicked,
    onSubcategoryClicked,
    onCategoryDoubleClicked,
    handleOnLifelinesClicked,
    difficultiesMap,
    setDifficultiesMap,
    canAnyTeamChooseAnyQuestion,
    setCanAnyTeamChooseAnyQuestion,
    shouldPlaySounds,
    setShouldPlaySounds,
    startGame,
    gameStartingLoading,
  };
}

export enum NewGamePage {
  CHOOSE_NAME = "ChooseName",
  SETTINGS = "Settings",
  CHOOSE_CATEGORIES = "ChooseCategories",
  CHOOSE_LIFELINES = "ChooseLifelines",
}
